import React from "react";
import { api, formatApiError } from "@/lib/api";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import StatusPill from "@/components/leaves/StatusPill";

export default function ApprovalsTable({ items, onDecided }) {
  const decide = async (id, status) => {
    try {
      await api.patch(`/leaves/${id}`, { status });
      toast.success(`Leave ${status}`);
      onDecided?.();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
  };

  return (
    <div className="overflow-hidden rounded-lg border border-[#e5e5e0] bg-white">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Employee</TableHead>
            <TableHead>Type</TableHead>
            <TableHead>From</TableHead>
            <TableHead>To</TableHead>
            <TableHead>Status</TableHead>
            <TableHead className="w-[200px]" />
          </TableRow>
        </TableHeader>
        <TableBody>
          {items.map((l) => (
            <TableRow key={l.id} data-testid={`leave-row-${l.id}`}>
              <TableCell className="font-medium">{l.employee_name}</TableCell>
              <TableCell className="capitalize">{l.leave_type}</TableCell>
              <TableCell className="font-mono text-xs">{l.start_date}</TableCell>
              <TableCell className="font-mono text-xs">{l.end_date}</TableCell>
              <TableCell><StatusPill status={l.status} /></TableCell>
              <TableCell className="text-right">
                {l.status === "pending" ? (
                  <div className="flex justify-end gap-2">
                    <Button
                      size="sm"
                      variant="outline"
                      data-testid={`leave-reject-${l.id}`}
                      onClick={() => decide(l.id, "rejected")}
                      className="h-7 border-[#e5e5e0] text-[#8f2c2c] hover:bg-[#fcecec]"
                    >
                      Reject
                    </Button>
                    <Button
                      size="sm"
                      data-testid={`leave-approve-${l.id}`}
                      onClick={() => decide(l.id, "approved")}
                      className="h-7 bg-[#4a6b53] text-white hover:bg-[#3d5a45]"
                    >
                      Approve
                    </Button>
                  </div>
                ) : (
                  <span className="text-xs text-[#8a8a80]">—</span>
                )}
              </TableCell>
            </TableRow>
          ))}
          {items.length === 0 && (
            <TableRow>
              <TableCell colSpan={6} className="py-10 text-center text-sm text-[#575752]">
                No leave requests.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
}
